import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityItem = ({ type, title, description, timestamp, status }) => {
  const getActivityIcon = () => {
    switch (type) {
      case 'upload':
        return { name: 'Upload', color: 'var(--color-success)' };
      case 'rating':
        return { name: 'Star', color: 'var(--color-warning)' };
      case 'request':
        return { name: 'MessageSquare', color: 'var(--color-accent)' };
      case 'category':
        return { name: 'FolderPlus', color: 'var(--color-secondary)' };
      default:
        return { name: 'Activity', color: 'var(--color-primary)' };
    }
  };

  const getStatusBadge = () => {
    if (!status) return null;
    
    const statusConfig = {
      pending: { bg: 'bg-warning/20', text: 'text-warning', label: 'Pendente' },
      approved: { bg: 'bg-success/20', text: 'text-success', label: 'Aprovado' },
      rejected: { bg: 'bg-error/20', text: 'text-error', label: 'Rejeitado' }
    };

    const config = statusConfig?.[status] || statusConfig?.pending;

    return (
      <span className={`px-2 py-1 rounded text-xs font-medium ${config?.bg} ${config?.text}`}>
        {config?.label}
      </span>
    );
  };

  const icon = getActivityIcon();

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 rounded-lg bg-muted/50 hover:bg-muted transition-smooth">
      <div 
        className="w-8 h-8 md:w-10 md:h-10 rounded-md flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: `${icon?.color}20` }}
      >
        <Icon name={icon?.name} size={20} color={icon?.color} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <h5 className="text-sm md:text-base font-medium text-foreground line-clamp-1">
            {title}
          </h5>
          {getStatusBadge()}
        </div>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-2 mb-2">
          {description}
        </p>
        <span className="text-xs text-muted-foreground">{timestamp}</span>
      </div>
    </div>
  );
};

export default ActivityItem;